import React, { memo, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { Text } from 'Component/Ajaib';
import styles from './style';

function PopUpCenter(props) {
  const {
    children,
    title,
    show,
    onHide,
    bgColor,
    modalSize = 'normal',
    style,
    styHeader,
    styBody,
    backdrop,
    keyboard,
    noPadding,
    titleShadow = false,
    paddingNone,
    ...rest
  } = props;

  let styleModal = {};
  if (style) {
    styleModal = { ...styleModal, ...style };
  }
  if (typeof title !== 'undefined' && title === '') {
    styleModal.boxShadow = 'none';
  }
  if (bgColor) {
    styleModal.backgroundColor = bgColor;
    styleModal.backgroundColor = 'none';
  }

  const modalContentHeader = titleShadow
    ? styles.modalCenterHeaderShadow
    : styles.modalCenterHeader;
  const styModalHeader = {
    ...modalContentHeader,
    ...styHeader,
  };

  const dialogClassNameModal = `modal-dialog-${modalSize}-size`;
  return (
    <Modal
      centered
      {...rest}
      show={show}
      dialogClassName={dialogClassNameModal}
      onHide={onHide}
      backdrop={backdrop}
      keyboard={keyboard}
    >
      {title && (
        <>
          <Modal.Header className="p-24" closeButton style={styModalHeader}>
            <Modal.Title as="div">
              <Text size="h2" bold>
                {title}
              </Text>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{ ...styBody, backgroundColor: bgColor }}
            className={noPadding ? 'p-0' : 'p-24'}
          >
            {children}
          </Modal.Body>
        </>
      )}
      {!title && (
        <Modal.Body
          style={{ ...styBody, backgroundColor: bgColor }}
          className={noPadding ? 'p-0' : 'p-24'}
        >
          {children}
        </Modal.Body>
      )}
    </Modal>
  );
}

export default memo(PopUpCenter);
